<div class="px-3 pb-3 flex-grow-1 d-flex flex-column position-relative" style="margin-top: 45px;">
  <app-breadcrumbs [hasCloseBtn]='false' [hasBackBtn]='false'></app-breadcrumbs>
  <app-content-heading title="Edit Profile" [icon]='faCog' [hasBreadcrumbs]='true'></app-content-heading>

  <div class="d-flex h-100 justify-content-center align-items-center" *ngIf="this.isLoadingSubscriptions">
    <div class="spinner-border text-primary subscription-spinner" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="flex-grow-1 content-container" *ngIf="!this.isLoadingSubscriptions">
    <div class="row">
      <div class="col-sm-8">

        <div *ngIf="this.isLoadingAccountDetails" class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>

        <p class="text-danger" *ngIf="!this.isLoadingAccountDetails && !this.accountDetails">Some error occured while fetching account details</p>

        <app-registration-form *ngIf="!this.isLoadingAccountDetails && this.accountDetails" #detailsForm (SubmitForm)='updateUser($event)' [showPassword]='false'
          [cloudUser]='this.accountDetails.primaryUser' [company]='this.accountDetails.companyDetails'
          [secondContactDetails]='this.accountDetails.secondaryUser'
          [HideButton]='true' [isEditing]='true' (hasMadeChangesToForm)='hasMadeChangesToForm($event)'
          [ShowSecondaryUserForm]='true' #AppRegistrationForm></app-registration-form>
      </div>
    </div>
  </div>
  <div class="nav-btn-container pt-3">
    
    <button
      class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width"
      [disabled]="true"
    >
      Previous
    </button>
    
    <button class="btn btn-nc me-3 btn-sm submit btn-primary btn-width" [disabled]="this.isSubmittingDetails" (click)="saveDetails()">
      <span *ngIf="this.isSubmittingDetails" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      Update
    </button>

    <button class="btn btn-sm btn-nc btn-outline-primary me-3 btn-width" [routerLink]="['/subscription']" (click)="this.navigateToDashboard()">
       Cancel
    </button>
  </div>
</div>
